import type React from "react";

import { ssoMessages } from "../StepSSO/StepSSOComponent";
import { VerificationStepsEnum } from "../../lib/types/runtimeTypes";

import { SingleSignOnPendingComponent } from "./SingleSignOnPendingComponent";

interface SSOPendingProps {
  logo: React.ReactNode;
  cancelSSO: () => void;
}

const SSOPending = ({ logo, cancelSSO }: SSOPendingProps) => (
  <SingleSignOnPendingComponent
    stepName={VerificationStepsEnum.sso}
    messages={ssoMessages}
    logo={logo}
    cancelSingleSignOn={cancelSSO}
  />
);

export const SSOPendingComponent = SSOPending;
